import { Document } from '@roc/feature-types';
import { Button, PrintableAreaRef, StandardDialog } from '@roc/ui';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useEffect, useRef } from 'react';
import PrintIcon from '@material-ui/icons/Print';
import { QUOTE_LOANS, TermSheetHtml } from '@roc/feature-documents';
import { InternalPortalModal } from '../../components/internalPortalModal';
import { useRocInternalPortalStore } from '../../hooks';
import { observer } from 'mobx-react';
import { useOneToolStore } from 'libs/feature-one-tool/src/quote/hooks/useOneToolStore';
import {
  DownloadableQuote,
  DownloadableTermSheet,
} from 'libs/feature-one-tool/src/quote/steps/summary/components/downloadableQuote';
import { useLoanStore } from '@roc/feature-loans';
import { LoanSubType, LoanType } from '@roc/feature-utils';
import { TermSheetRentalHTML } from 'libs/feature-documents/src/documents/components/documentForms/termSheet/termSheet/termSheetRentalHTML';

const DOCUMENT_NAME = 'Term Sheet.pdf';

export const TermSheetInternalDialog = observer(() => {
  const termSheetRef = useRef<PrintableAreaRef>(null);
  const { termSheetInternalStore } = useRocInternalPortalStore();
  const { termSheetData } = termSheetInternalStore;
  const { loanStore } = useLoanStore();

  useEffect(() => {
    termSheetInternalStore.fetchTermSheetData();
  }, []);

  const downloadTermSheet = () => {
    termSheetRef.current.downloadAsPdf(DOCUMENT_NAME);
  };

  const printTermSheet = async () => {
    const url = await termSheetRef.current.getPdfBlobUrl();
    const printWindow = window.open(url.toString(), '_blank');
    printWindow?.print();
  };

  const dialogActions = (
    <>
      <Button
        style={{ marginRight: '8px' }}
        testId="print-pdf"
        color="default"
        variant="contained"
        onClick={printTermSheet}
        startIcon={<PrintIcon />}
      >
        Print
      </Button>
      <Button
        testId="download-pdf"
        color="primary"
        variant="contained"
        startIcon={<GetAppIcon />}
        onClick={downloadTermSheet}
      >
        Download
      </Button>
    </>
  );

  const getTermSheetContent = () => {
    if (termSheetData) {
      if (
        termSheetData?.loanProgram === LoanSubType.SINGLE_PROPERTY ||
        termSheetData?.loanProgram === LoanSubType.RENTAL_PORTFOLIO
      ) {
        return (
          <TermSheetRentalHTML
            ref={termSheetRef}
            data={termSheetData}
            loan={termSheetData?.loanDetails}
          />
        );
      }
      if (QUOTE_LOANS.includes(termSheetData?.loanProgram)) {
        return (
          <DownloadableTermSheet
            ref={termSheetRef}
            termSheetData={termSheetData}
            loan={termSheetData?.loanDetails}
          />
        );
      } else {
        return <TermSheetHtml ref={termSheetRef} data={termSheetData} />;
      }
    }
  };

  return (
    <InternalPortalModal
      title="Term Sheet"
      maxWidth="md"
      dialogActions={dialogActions}
      dialogContent={termSheetData ? getTermSheetContent() : null}
    />
  );
});
